import { render } from "./EmptyProductPage.vue?vue&type=template&id=06415220&scoped=true"
import script from "./EmptyProductPage.vue?vue&type=script&lang=js"
export * from "./EmptyProductPage.vue?vue&type=script&lang=js"

import "./EmptyProductPage.vue?vue&type=style&index=0&id=06415220&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06415220"]])

export default __exports__